import { Component } from '@angular/core';

@Component({
  selector: 'main-page',
  templateUrl: './main.component.html'
})
export class MainComponent {
  model = 1;
  inputString = '';
}


// WEBPACK FOOTER //
// C:/Users/leoth/Desktop/Leo/Programming/Hackathons/Octocite/octocite/src/app/main.component.ts